import disbleFields from "../utils/disableFields";
import { getDescriptionMessage } from "../utils/getDescriptionMessage";
import { getToken } from '../../../../services/formServices';
import { getRegistry, getSapFosfecState } from '../../../../services/fosfec.services';
import { numDate2String } from '../utils/numDate2String';

export const watcherStatusJob = async (watcher : any, 
    setModalContent : any, 
    setValue : any,
    setIsOpenModal : any,
    setError: any,
    fields : any, 
    ContextGygia : any, 
    modalBlockActaullyWorking :any) => {
    try {
        setValue("statusJob", "");
        if (watcher === "NO" && ContextGygia.gigyaAccount) {
        const token = await getToken();
        const dataRegistry = await getRegistry({ 
            typeDoc : ContextGygia.gigyaAccount.data.docType, 
            document : ContextGygia.gigyaAccount.data.docNumber,
            update : "false" },
            token.data.data.id_token)
            disbleFields(fields,["expeditionDate","firstName","secondName","lastName","secondLastName","idNum","idNumType"]);

        const dataFosfecSapState = await getSapFosfecState({ 
            typeDoc : ContextGygia.gigyaAccount.data.docType, 
            document : ContextGygia.gigyaAccount.data.docNumber},
            token.data.data.id_token)
            if(dataRegistry.data && dataFosfecSapState.data){
            const isActuallySate = dataRegistry.data.moreInfo.toLowerCase() === "true";
            const isAcceptedSapStateAndNotRegistred = dataFosfecSapState.data.moreInfo.toLowerCase() === "true";
            if(!isActuallySate || !isAcceptedSapStateAndNotRegistred){ 
                setModalContent({   
                    title: modalBlockActaullyWorking.title ? modalBlockActaullyWorking.title : "",
                    image: modalBlockActaullyWorking.icon ? modalBlockActaullyWorking.icon : "",
                    description: !isActuallySate ? getDescriptionMessage.isNotCurrentStateRegitry.replace("{status}", dataRegistry.data.userMessage) : !isAcceptedSapStateAndNotRegistred && dataFosfecSapState.data.userMessage,
                    textButton: modalBlockActaullyWorking.primaryButton.title ? modalBlockActaullyWorking.primaryButton.title : "",
                    url: modalBlockActaullyWorking.primaryButton.url ? modalBlockActaullyWorking.primaryButton.url : "",
                    openSelf : true,
                });
                
                setIsOpenModal(true);
                setValue("statusJob", "");
                return;
            }

            const setUserValues = (values: any[]) => {
               values.forEach((value: any) => {
                  setValue(value.campo, value.valor);
               });
            };
            
            const isSameDocument = dataRegistry.data.data.Documento === ContextGygia.gigyaAccount.data.docNumber;
            const dataSource = isSameDocument ? dataRegistry.data.data : 
               dataRegistry.data.data.Pacs.find((pac: any) => pac.pacnumeroDocumento === ContextGygia.gigyaAccount.data.docNumber);
            
            const userValues = [
               {campo: "statusJob", valor: "NO"},
               {campo: "expeditionDate", valor: isSameDocument ? numDate2String(dataRegistry.data.data.Fecha_Expedicion) : ""},
               {campo: "firstName", valor: isSameDocument ? dataSource.Primer_Nombre : dataSource.pacprimerNombre},
               {campo: "secondName", valor: isSameDocument ? dataSource.Segundo_Nombre ?? "" : dataSource.pacsegundoNombre ?? ""},
               {campo: "lastName", valor: isSameDocument ? dataSource.Primer_Apellido : dataSource.pacprimerApellido},
               {campo: "secondLastName", valor: isSameDocument ? dataSource.Segundo_Apellido ?? "" : dataSource.pacsegundoApellido ?? ""},
               {campo: "idNum", valor: isSameDocument ? dataSource.Documento : dataSource.pacnumeroDocumento},
               {campo: "idNumType", valor: isSameDocument ? dataSource.Tipo_Doc : dataSource.pactipoDocumento}
            ];
            
            setUserValues(userValues);
        } else {
            setModalContent({   
                title: modalBlockActaullyWorking.title ? modalBlockActaullyWorking.title : "",
                image: modalBlockActaullyWorking.icon ? modalBlockActaullyWorking.icon : "",
                description: getDescriptionMessage.servicesUnavailableFailed,
                textButton: modalBlockActaullyWorking.primaryButton.title ? modalBlockActaullyWorking.primaryButton.title : "",
                url: modalBlockActaullyWorking.primaryButton.url ? modalBlockActaullyWorking.primaryButton.url : "",
                openSelf : true,
            });
            setIsOpenModal(true);
            return;
        }

        } else if (watcher=== "SÍ") {
            setModalContent({   
                title: modalBlockActaullyWorking.title ? modalBlockActaullyWorking.title : "",
                image: modalBlockActaullyWorking.icon ? modalBlockActaullyWorking.icon : "",
                description: modalBlockActaullyWorking.description ? modalBlockActaullyWorking.description : "",
                textButton: modalBlockActaullyWorking.primaryButton.title ? modalBlockActaullyWorking.primaryButton.title : "",
                url: modalBlockActaullyWorking.primaryButton.url ? modalBlockActaullyWorking.primaryButton.url : setIsOpenModal(false),
                textButtonOpcional: modalBlockActaullyWorking.secundaryButton.title ? modalBlockActaullyWorking.secundaryButton.title : "",
                urlOpcional: modalBlockActaullyWorking.secundaryButton.url ? modalBlockActaullyWorking.secundaryButton.url : "",
                openSelf : true,
            });
            setIsOpenModal(true);
        }
    } catch (error) {
        console.log(error);
        setModalContent({   
            title: modalBlockActaullyWorking.title ? modalBlockActaullyWorking.title : "",
            image: modalBlockActaullyWorking.icon ? modalBlockActaullyWorking.icon : "",
            description: getDescriptionMessage.servicesUnavailableFailed,
            textButton: modalBlockActaullyWorking.primaryButton.title ? modalBlockActaullyWorking.primaryButton.title : "",
            url: modalBlockActaullyWorking.primaryButton.url ? modalBlockActaullyWorking.primaryButton.url : "",
            openSelf : true,
        });
        setIsOpenModal(true);
        setError(true);
    }
}
